import React, { useState } from 'react';

function HelpCenter() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        subject: '',
        category: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission (e.g., sending an email)
        console.log('Form Data Submitted:', formData);
        alert('Your message has been sent!');
    };

    return (
        <div className="help-center">
            <h1><strong>Did we forget something?</strong></h1>
            <p>
                We don't bite. <a href="mailto:digitalwardrobe@info.com">Get in touch with our support team</a> if you’ve got any more questions.
            </p>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label><strong>Full Name</strong>*</label>
                    <div className="name-fields">
                        <input
                            type="text"
                            name="firstName"
                            placeholder="First name"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Last name"
                            value={formData.lastName}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label><strong>E-mail</strong>*</label>
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label><strong>Subject</strong>*</label>
                    <input
                        type="text"
                        name="subject"
                        placeholder="Subject of message"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label><strong>What's on your mind?</strong>*</label>
                    <textarea
                        name="message"
                        placeholder="Write your message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>
                </div>

                <div className="form-group">
                    <label><strong>Select a category:</strong></label>
                    <select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                    >
                        <option value="">Select</option>
                        <option value="The Web App">The Web App</option>
                        <option value="Feedback">Feedback</option>
                        <option value="Support">Support</option>
                    </select>
                </div>

                <button type="submit" className="send-btn">SEND</button>
            </form>
        </div>
    );
}

export default HelpCenter;
